import './employeeBenefits.scss';
import * as React from 'react';
import Swiper from 'react-id-swiper';
import * as ReactMarkdown from 'react-markdown';
import useJoinBenefits from '../../hooks/staticQueries/join/useJoinBenefits';
import { SwiperUtils } from '../../utils/swiper';
import { SectionTitle } from '../layout/sectionTitle';
import { LazyCosmosImage } from '../media/cosmosImage';
const EmployeeBenefit = ({ icon, title, description }) => (<div className="employee-benefit">
    <div className="benefit-image">
      <LazyCosmosImage ticket={icon[0].ticket} alt={title}/>
    </div>
    <div className="benefit-description">
      <h3>{title}</h3>
      <ReactMarkdown source={description}/>
    </div>
  </div>);
export const EmployeeBenefits = () => {
    const { benefits } = useJoinBenefits();
    const swiperProps = React.useMemo(() => ({
        ...SwiperUtils.Config.defaults(),
        ...SwiperUtils.Config.autoplay(),
        ...SwiperUtils.Config.navigation('black'),
        ...SwiperUtils.Config.perView(5, {
            1024: 4,
            800: 3,
            590: 2,
            328: 1,
        }),
    }), []);
    return (<div className="employee-benefits-wrapper">
      <SectionTitle title="Employee Benefits" className="benefits-title"/>

      <div className="employee-benefits">
        <Swiper {...swiperProps}>
          {benefits.employee_benefits.map((benefit, i) => (<div key={i}>
              <EmployeeBenefit {...benefit} key={benefit.title}/>
            </div>))}
        </Swiper>
      </div>
    </div>);
};
